
import { defineComponent } from "vue";
import GenericPanel from "./GenericPanel.vue";

export default defineComponent({
    name: "Header",
    components: { GenericPanel }
});
